'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconClone, iconCloneTag } from '@ni/nimble-components/dist/esm/icons/clone';
import { wrap } from '../../utilities/react-wrapper';

export type { IconClone };
export { iconCloneTag };
export const NimbleIconClone = wrap(IconClone);